import { render, staticRenderFns } from "./ItemRates.vue?vue&type=template&id=2889be04&"
import script from "./ItemRates.vue?vue&type=script&lang=js&"
export * from "./ItemRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports